import React from 'react';
import ColorCodePreamble from './animalCountBreakdownParts/colorCodePreamble.js';
import AnimalCountPreamble from './animalCountBreakdownParts/countPreamble.js';
import AnimalCountChart from './animalCountBreakdownParts/countChart.js';
import { capitalizeFirstLetter } from '../../util/helperFunctions';
import { Box } from 'bloomer/lib/elements/Box';
import { Title } from 'bloomer/lib/elements/Title';
import { Columns } from 'bloomer/lib/grid/Columns';
import { Column } from 'bloomer/lib/grid/Column';
import { Section } from 'bloomer/lib/layout/Section';

export default function DogCountBreakdown({
	startDate,
	endDate,
	data,
	colors,
	animalCountArray,
	animalCountAverage,
	animalCountChart,
	colorCode__animalCountArray,
	colorCode__animalsByDate,
	colorCode__animalCountChart,
	possibleColors,
	animalType
}) {
	return (
		<Box className="on-print-own-page">
			<Title tag="h3">{capitalizeFirstLetter(animalType)} Census Breakdown:</Title>
			<Section>
				<AnimalCountPreamble
					startDate={startDate}
					endDate={endDate}
					animalCountArray={animalCountArray}
					animalCountAverage={animalCountAverage}
					colors={colors}
					animalType={animalType}
				/>
				<AnimalCountChart
					color={colors[colors.length - 1]}
					data={animalCountChart}
					animalType={animalType}
				/>
			</Section>
			<Section>
				<AnimalCountPreamble
					startDate={startDate}
					endDate={endDate}
					animalCountArray={animalCountArray}
					animalCountAverage={animalCountAverage}
					colorCodeMode={colorCode__animalCountArray}
					colors={colors}
					animalType={animalType}
				/>
				<Columns>
					<Column>
						<ColorCodePreamble colors={colors} colorCounts={colorCode__animalCountArray} animalType={animalType} />
					</Column>
					<Column className="on-print-is-one-half">
						<AnimalCountChart
							possibleColors={possibleColors}
							colors={colors}
							data={colorCode__animalCountChart}
							animalType={animalType}
						/>
					</Column>
				</Columns>
			</Section>
		</Box>
	);
}
